import axios from 'axios'

/** 内部券类型 → 用户可见名称（不含金额、分润等业务细节） */
export const COUPON_TYPE_LABELS = {
  normal: '双享礼券',
  partner: '臻享礼券',
  cash: '专享礼券'
}

/** 券类型简要说明（绑定页、创建页） */
export const COUPON_TYPE_HINTS = {
  normal: '绑定后双方均可获得平台礼遇',
  partner: '绑定后可享长期专属权益',
  cash: '绑定后可获得平台礼遇'
}

/** 创建券时的下拉选项（臻享礼券需伙伴资格，由页面按 isPartner 追加） */
export const COUPON_TYPE_CREATE_OPTIONS = [
  { value: 'normal', label: '双享礼券', hint: '双方均可获得礼遇' },
  { value: 'cash', label: '专享礼券', hint: '绑定者可获得礼遇' },
  { value: 'partner', label: '臻享礼券', hint: '长期专属权益', partnerOnly: true }
]

export function couponTypeLabel(type) {
  return COUPON_TYPE_LABELS[type] || type || '—'
}

export function couponTypeHint(type) {
  return COUPON_TYPE_HINTS[type] || ''
}

export async function checkReferralCoupon(couponNo) {
  const no = (couponNo || '').trim()
  if (!no) return { valid: false, message: '' }
  const res = await axios.get('/api/v1/referral/coupon/check', { params: { couponNo: no } })
  return res.data?.data || { valid: false, message: res.data?.message || '推荐券无效' }
}

export async function bindReferralCoupon(couponNo) {
  const no = (couponNo || '').trim()
  if (!no) throw new Error('请输入推荐券号码')
  const res = await axios.post('/api/v1/referral/bind', { couponNo: no })
  if (res.data?.code !== 200) {
    throw new Error(res.data?.message || '绑定失败')
  }
  return res.data
}

export async function fetchReferralBindStatus() {
  const res = await axios.get('/api/v1/referral/bind/status')
  if (res.data?.code !== 200) {
    throw new Error(res.data?.message || '加载失败')
  }
  return res.data.data || {}
}
